module.exports = __webpack_public_path__ + "img/check.2a08b40d.svg";